import { webApiBuildUrl } from '@api/utils'

function filterListUrl(): string

function filterListUrl() {
    return webApiBuildUrl('api/catalog/filters/list')
}

export { filterListUrl }
